import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControlLabel, Checkbox } from '@material-ui/core';
import { Tooltip } from '@mui/material';
import { InfoSignIcon } from 'evergreen-ui';

const useStyles = makeStyles((theme) => ({
  checkbox: {
    margin: '0 8px 8px 0',
  },
  checkboxError: {
    margin: '0 8px 0px 0',
    color: theme.palette.error.main,
    '& svg': {
      color: theme.palette.error.main,
    },
  },
}));

function Checkbox2(props) {
  const classes = useStyles();
  const { error, name, checked, label, disabled, tooltipText } = props;
  const className = error ? classes.checkboxError : classes.checkbox;

  const onChange = (ev) => {
    if (props.onChange) props.onChange(ev, ev.target.checked);
  }

  return (
    <FormControlLabel
      control={<Checkbox checked={checked} onChange={onChange} name={name} disabled={disabled} />}
      label={
        <span style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
          {label}
          {tooltipText && tooltipText.length > 0 && (
            <Tooltip title={tooltipText}>
              <InfoSignIcon style={{ fontSize: 20, color: '#178CEA', cursor: 'pointer' }} />
            </Tooltip>
          )}
        </span>
      }
      className={className}
    />
  );
}

export default Checkbox2;
